export default __webpack_public_path__ + "static/media/arrow-dropdown.e920df64.svg";